module.exports = __webpack_public_path__ + "img/15.4209f602.jpg";